import React from "react";
import img1 from "../assets/satyam.jpg";
import img2 from "../assets/mithilesh 1.jpeg";
import img3 from "../assets/lalal.jpg";

const Testimonial = () => {
  return (
    <div id="testimonial">
      <h2>Testimonial</h2>

      <section>
        <TestimonialCard
          imgSrc={img1}
          name={"Satyam Yadav"}
          feedback={"You Have good knowledge of the technology and you know how to apply it efficiently."}
        />

        <TestimonialCard
          imgSrc={img2}
          name={"Mithilesh"}
          feedback={
            "Wow what a portfolio, “You often find new and innovative solutions to a problem.”!"
          }
        />

        <TestimonialCard
          imgSrc={img3}
          name={"Lalan Yadav"}
          feedback={"“You have a unique imagination and have come up with some of the most creative design and Animation we’ve ever seen.”"}
        />
      </section>
    </div>
  );
};

const TestimonialCard = ({ name, feedback ,imgSrc}) => (
  <article>
    <img
      src={imgSrc}
      alt="User"
    />
    <h4>{name}</h4>
    <p>{feedback}</p>
  </article>
);

export default Testimonial;
